import axios from 'axios';
import { notification } from 'antd';

export const baseURL = 'https://devapi2.edves.net/personalized-learning/api/v2';

let headers = {};

let token = localStorage.getItem('token');

if (token) {
  headers.Authorization = `Bearer ${token}`;
}

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers,
});

axiosInstance.interceptors.response.use(
  (response) =>
    new Promise((resolve, reject) => {
      resolve(response);
    }),
  (error) => {
    if (!error.response) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }

    if (error.response.status === 401) {
      if (error.response.data.message === 'Invalid login credentials') {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      } else {
        notification['error']({
          message: 'Session expired, please login again',
        });
        window.location.replace('/login');
        localStorage.clear();
      }
    } else {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  }
);

export default axiosInstance;
